import React, { useState } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { DETAIL_ACTIONS } from "../../../../../../constants/Define";
import { capitalizeFirstLetter } from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import ListHotel from "../ListHotel";

const defaultCollapseKey = "campaignUseHotel";

function UseHotelSection(props) {
  const {
    campaign,
    action,
    setCampaign,
    getAllHotel,
    getAllHomestay,
    getListRates,
    hotelState,
    homestayState,
    ratePlansGroup
  } = props;
  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const onChangeHotelRate = (hotelIds, rateCodes) => {
    if (hotelIds && hotelIds.length > 0 && rateCodes && rateCodes.length > 0) {
      const hotelRatePlans = [];
      hotelIds.map(itemHotel => {
        const existedHotelObj = hotelRatePlans.filter(item => {
          return item.id === itemHotel;
        });
        if (
          itemHotel &&
          (!existedHotelObj || (existedHotelObj && existedHotelObj.length <= 0))
        ) {
          const hotelRatePlanObj = {
            id: itemHotel,
            rateCodes: []
          };
          const arrRateCodes = [];
          rateCodes.map(itemRateCode => {
            if (itemRateCode) {
              const arrRateCode = itemRateCode.split(":");
              if (arrRateCode && arrRateCode.length > 0) {
                const hotelId = arrRateCode[0];
                const rateCode = arrRateCode[1];
                if (hotelId === itemHotel && !arrRateCodes.includes(rateCode)) {
                  arrRateCodes.push(rateCode);
                }
              }
            }
          });
          hotelRatePlans.push({
            ...hotelRatePlanObj,
            rateCodes: arrRateCodes
          });
        }
      });
      setCampaign({
        ...campaign,
        totalRateConfiged: rateCodes.length,
        hotel: {
          ...campaign.hotel,
          hotelRatePlans: hotelRatePlans
        }
      });
    } else {
      setCampaign({
        ...campaign,
        totalRateConfiged: rateCodes.length,
        hotel: {
          ...campaign.hotel,
          hotelRatePlans: []
        }
      });
    }
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.hotels")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <ListHotel
                buttonText={capitalizeFirstLetter(
                  (
                    t("action.select") +
                    ` ` +
                    t("item.campaign.hotels")
                  ).toLowerCase()
                )}
                getAllHotel={getAllHotel}
                getAllHomestay={getAllHomestay}
                getListRates={getListRates}
                allHotels={hotelState.allHotels}
                allHomestays={homestayState.allHomestays}
                ratePlans={ratePlansGroup}
                onChange={(listHotels, lstRateCodes) =>
                  onChangeHotelRate(listHotels, lstRateCodes)
                }
                action={action}
                hotelData={campaign?.hotel?.hotelRatePlans}
                campaign={campaign}
              />
              {campaign.totalRateConfiged &&
              parseInt(campaign.totalRateConfiged) > 0 ? (
                <span className="ml-2">
                  {`${t(`item.campaign.selectedRateCodes`)} ${
                    campaign.totalRateConfiged
                  } ${t(`item.campaign.selectedRateCodesSuffix`)}`}
                </span>
              ) : (
                ""
              )}
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

UseHotelSection.propTypes = {
  campaign: PropTypes.object,
  hotelState: PropTypes.object,
  action: PropTypes.string,
  setCampaign: PropTypes.func,
  getAllHotel: PropTypes.func,
  getAllHomestay: PropTypes.func,
  getListRates: PropTypes.func,
  ratePlansGroup: PropTypes.func
};

UseHotelSection.defaultProps = {
  campaign: {},
  hotelState: {},
  action: "",
  setCampaign: () => {},
  getAllHotel: () => { },
  getAllHomestay: () => { },
  getListRates: () => {},
  ratePlansGroup: () => {}
};

export default UseHotelSection;
